import styled from 'styled-components';

export type TeamsCellProps = {
  color?: string;
};

export const TeamsCell = styled.div<TeamsCellProps>`
  padding: 6px;
  background-color: ${(props) => props.color || 'var(--color-surface-muted)'};
  color: ${(props) => (props.color ? 'var(--color-surface)' : 'var(--color-text)')};
  font-weight: 500;
  font-size: 12px;
  line-height: 90%;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  text-wrap: nowrap !important;
  white-space: nowrap !important;
`;
